/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DatetimeInterval,
    DatetimeIntervalFromJSON,
    DatetimeIntervalFromJSONTyped,
    DatetimeIntervalToJSON,
} from './DatetimeInterval';

/**
 * 
 * @export
 * @interface SummaryRequestBody
 */
export interface SummaryRequestBody {
    /**
     * List of UTC intervals to fetch statistics for
     * @type {Array<DatetimeInterval>}
     * @memberof SummaryRequestBody
     */
    intervals: Array<DatetimeInterval>;
}

export function SummaryRequestBodyFromJSON(json: any): SummaryRequestBody {
    return SummaryRequestBodyFromJSONTyped(json, false);
}

export function SummaryRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intervals': ((json['intervals'] as Array<any>).map(DatetimeIntervalFromJSON)),
    };
}

export function SummaryRequestBodyToJSON(value?: SummaryRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intervals': ((value.intervals as Array<any>).map(DatetimeIntervalToJSON)),
    };
}

